import { defineMessages } from 'react-intl'

export default defineMessages({
  toast: { id: 'portfolio.share.toast', defaultMessage: 'Poveznica kopirana' },
  title: { id: 'portfolio.share.title', defaultMessage: 'Kopiraj poveznicu' },
})
